//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name:'AMTS',
  data() {
    return {
      form:{
        age:'0',
        time:'0',
        address:'0',
        year:'0',
        hospital:'0',
        recognize:'0',
        dob:'0',
        wwi:'0',
        leader:'0',
        count:'0',
      },
      hasScore:false,
      disabled:false,
      defaultJson:{
        "Recognizes 2 People": "认识 2 人",
        "Can Repeat Address (given at beginning of test)": "能说出测试初期给出的地址",
        "Knows Date of Birth": "知道生日",
        "Knows Hospital Name": "知道医院名字",
        "Knows Name of Cur. Leader": "知道目前领导人姓名",
        "Suggestive of delirium or dementia": "提示存在瞻望或痴呆",
        "Knows Age": "知道年龄",
        "Knows Year": "知道年份",
        "Can Count 20 ➙ 1": "能够计数：20 ➙ 1",
        "Knows Time (nearest hour)": "知道时间（小时）",
        "Knows Date of Major Event": "知道重大事件的日期"
      },
    }
  },
  created () {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad']),
  },
  computed: {
    /** 计算主要标准 */
    score() {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
            form[key]=0
          } else { 
            form[key] = Number(form[key])
          }
        }
      }
      // (age ? 1 : 0) + (time ? 1 : 0) + (address ? 1 : 0) + (year ? 1 : 0) + (hospital ? 1 : 0) + (recognize ? 1 : 0) + (dob ? 1 : 0) + (wwi ? 1 : 0) + (leader ? 1 : 0) + (count ? 1 : 0)
      let result = (form.age ? 1 : 0) + (form.time ? 1 : 0) + (form.address ? 1 : 0) + (form.year ? 1 : 0) + (form.hospital ? 1 : 0) + (form.recognize ? 1 : 0) + (form.dob ? 1 : 0) + (form.wwi ? 1 : 0) + (form.leader ? 1 : 0) + (form.count ? 1 : 0)
      self.hasScore = true
      return String(result)
    },
  },
  
  
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Neuro/AMTS.vue